import { render, staticRenderFns } from "./TheSoldInTheLastTwoWeeks.vue?vue&type=template&id=fb04158e"
import script from "./TheSoldInTheLastTwoWeeks.vue?vue&type=script&lang=ts"
export * from "./TheSoldInTheLastTwoWeeks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreSearchFiltersTheSwitch: require('/usr/src/nuxt-app/components/core/search/filters/TheSwitch.vue').default})
